import { render, staticRenderFns } from "./expansionCustom.vue?vue&type=template&id=277f13ca&scoped=true&"
import script from "./expansionCustom.vue?vue&type=script&lang=js&"
export * from "./expansionCustom.vue?vue&type=script&lang=js&"
import style0 from "./expansionCustom.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./expansionCustom.vue?vue&type=style&index=1&id=277f13ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277f13ca",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('277f13ca')) {
      api.createRecord('277f13ca', component.options)
    } else {
      api.reload('277f13ca', component.options)
    }
    module.hot.accept("./expansionCustom.vue?vue&type=template&id=277f13ca&scoped=true&", function () {
      api.rerender('277f13ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/expansionCustom.vue"
export default component.exports